import "./AboutUs.css";
import { MdLocationOn } from "react-icons/md"; // Location Icon
import { FaPhone, FaEnvelope } from "react-icons/fa";
import ceo from "../images/ceo.jpg"; // CEO Image
import Kilimambogo from "../images/coolbreeze/kilimambogo1.jpg"; // Kilimambogo Image
import Malindi from "../images/imani/malindi1.jpg"; // Malindi Image
import Matuu from "../images/springview/matuu1.jpeg"; // Matuu Image

const AboutUs = () => {

    return (
        <>
         <div className="about-container">

            <div className="message-container">

                <div className="message-section">
                   <div className="message-heading">
                     <h2>Message from Moses Kiarie, the CEO, Faidika Real Estate</h2>
                   </div>
                    <div className="message-text">
                        <p className="normal">"Welcome to Faidika Real Estate! Our mission is to help you secure your future through prime land 
                            investments in various parts of the country. With a commitment to transparency, professionalism, 
                            and customer satisfaction, we strive to make your land buying experience seamless and rewarding. 
                            Thank you for choosing Faidika Real Estate.”</p>

                        <p className="sign"><b>— Moses Kiarie, CEO</b></p>
                    </div>
                </div>

                <div className="image-section">
                    <img src={ceo} alt="CEO" className="ceo-image"  />
                </div>
            </div>

            <div className="who-we-are">
                <div className="column-start">
                    <div className="column-header">
                        <h2>Who We Are</h2>
                    </div>
                    <div className="location">
                        <div className="contact-row">
                            <MdLocationOn className="location-icon" />
                            <span>Spur Mall Ruiru Kimbo</span>
                        </div>
                        <div className="contact-row">
                            <FaPhone className="location-icon" />
                            <span>+254 717 520 520</span>
                        </div>
                        <div className="contact-row">
                            <FaEnvelope className="location-icon" />
                            <span>info@faidika.com</span>
                        </div>
                    </div>

                </div>

                <div className="column">
                    <div className="column-text">
                        <p>
                            <b>Faidika Real Estate </b>is a leading land investment company dedicated to providing prime plots in Kenya. 
                            Our focus is on offering a diverse range of land sizes, including 1/8th acre, 1/4 acre, and full 
                            acre plots, catering to both residential and investment needs. With a strong commitment to transparency, 
                            integrity, and professionalism, we ensure that every transaction is smooth and secure, providing our 
                            clients with peace of mind and confidence in their investment.
                        </p>
                    </div>
                </div>

                <div className="column">
                   <div className="column-text">
                        <p>
                           At Faidika Real Estate, we pride ourselves on our deep understanding of the Kenyan real estate market 
                           and our ability to deliver exceptional value to our clients. Our experienced team is passionate about 
                           helping you achieve your property goals, whether it’s building your dream home or making a strategic 
                           investment. We are dedicated to providing outstanding customer service and support throughout your 
                           land buying journey, making <b>Faidika Real Estate your trusted partner in land ownership</b>.
                        </p>
                    </div>
                </div>
            </div>

            <div className="mission-vision">
                <div className="mission">
                    <div className="mision-header">
                        <h2>Mission</h2>
                    </div>
                    <div className="mission-text">
                        <p>
                        To empower individuals and families by providing prime land investment opportunities in Malindi, Kenya, 
                        through transparent, professional, and customer-centric services.
                        </p>
                    </div>
                </div>
                <div className="vision">
                    <div className="vision-header">
                        <h2>Vision</h2>
                    </div>
                    <div className="vision-text">
                        <p>
                           To be the leading real estate company in Kenya, recognized for our integrity, innovation, and commitment 
                           to helping our clients achieve their property dreams.
                        </p>
                    </div>
                </div>
            </div>

            <div className="core-values">
                <div className="core-values-image">
                    <img src={ceo} alt="Core Values" className="core-values-img" />
                </div>
                <div className="core-values-text">
                    <div className="heading">
                        <h2>Our Core Values</h2>
                    </div>
                    <div className="row-section">
                        <div className="row-item">
                            <h3>01. Integrity</h3>
                            <p>We uphold the highest ethical standards in all our transactions, ensuring honesty and transparency in every deal.</p>
                        </div>
                        <div className="row-item">
                            <h3>02. Customer Focus</h3>
                            <p>Our clients are at the heart of everything we do. We strive to exceed their expectations by providing exceptional services.</p>
                        </div>
                        <div className="row-item">
                            <h3>03. Professionalism</h3>
                            <p>We maintain a high level of professionalism, ensuring reliable & expert guidance in the land buying process</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="product-container">
                <div className="container-heading">
                    <h3>Have A look at our Various Projects</h3>
                </div>
                <div className="product-grid">
                    {/*Card 1*/}
                    <div className="card">
                        <div className="card-image">
                            <img src={Matuu} alt="Springview Gardens" className="project-image" />
                        </div>
                        <div className="card-text">
                            <h4>Springview Gardens</h4>
                            <p>Location: Matuu</p>
                            <p>Price: Ksh 295,000</p>
                            <p>Size: 1/8 acre</p>
                        </div>
                        <div className="card-button">
                            <button className="view-button">View Details</button>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-image">
                            <img src={Kilimambogo} alt="Cool Breeze Gardens" className="project-image" />
                        </div>
                        <div className="card-text">
                            <h4>Cool Breeze Gardens</h4>
                            <p>Location: Kilimambogo</p>
                            <p>Price: Ksh 350,000</p>
                            <p>Size: 1/8 acre</p>
                        </div>
                        <div className="card-button">
                            <button className="view-button">View Details</button>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-image">
                            <img src={Malindi} alt="Furaha City" className="project-image" />
                        </div>
                        <div className="card-text">
                            <h4>Furaha City</h4>
                            <p>Location: Malindi</p>
                            <p>Price: Ksh 125,000</p>
                            <p>Size: 1/4 acre</p>
                        </div>
                        <div className="card-button">
                            <button className="view-button">View Details</button>
                        </div>
                    </div>
                </div>
            </div>


         </div>

        
        </>
    );

}
export default AboutUs;